import { AppHandler } from '../work-modules/016/AppHandler';

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('webgl-canvas') as HTMLCanvasElement;
  const app = new AppHandler(canvas);
  app.initialize();
});